// @ts-nocheck
export const selectOrders = state => state.order.orders?.data;
export const selectOrderDetails = state => state.order.orderDetails;
